<template>
  <div class="nopads">
      <!-- Header of collapsable item -->
      <div class="col-12 d-flex justify-content-between align-items-center pb-1">
          <div class="flex-grow-1">
              <h4 class="form-header pointer hover-header" @click.stop="reportsVisible = !reportsVisible">
                  {{ $t('traffic_control.report_title') }} ({{ trafficControlItems.length }})
              </h4>
          </div>
          <div
              v-if="loading"
              id="loader"
              class="spinner-section"
          />
          <div v-else class="ms-2 px-2" @click.stop="reportsVisible = !reportsVisible">
              <font-awesome-icon icon="arrow-down" class="pointer no-focus arrow-icon dont-print hover-header" :class="{ rotated:reportsVisible }"/>
          </div>
      </div>
      <!-- Collapsable content -->
      <div class="routa-collapse" :class="{ collapsed: reportsVisible }">
          <traffic-control-report-list :results="trafficControlItems" class="my-2" @details="showDetails"/>
      </div>
      <traffic-control-report-details
        v-if="trafficControlItem !== null"
        id="details"
        ref="details"
        :report="trafficControlItem"
        :is-observer="isObserver"
        @close="trafficControlItem = null"
        @close-and-update="closeAndUpdate"
      />
    <hr class="report-divider nopads">
  </div>
</template>


<script>
import {timeUtils} from "@/components/mixins/TimeUtils";
import {restApi} from "@/components/mixins/RestApiMixin";
import TrafficControlReportList from "@/components/trafficcontrol/TrafficControlReportList";
import TrafficControlReportDetails from "@/components/trafficcontrol/TrafficControlReportDetails";
import BaseModal from "@/components/BaseModal";

export default {
    name: "TrafficControlReports",
    components: {
        BaseModal,
        TrafficControlReportDetails,
        TrafficControlReportList
    },
    mixins: [timeUtils, restApi],
    props: {
        searchParams: {
            type: Object,
            default() {
                return null
            }
        },
        isObserver: Boolean,
    },
    data: function () {
        return {
            loading: false,
            trafficControlItems: [],
            trafficControlItem: null,
            reportsVisible: false,
        }
    },
    watch: {
      searchParams () {
          this.fetchTrafficControlReports()
      }
    },
    mounted() {
        this.fetchTrafficControlReports()
    },
    methods: {
        fetchTrafficControlReports: function () {
            this.trafficControlItems = []
            if (this.searchParams) {
                let mappedParams = {
                    contract: this.searchParams.contract ? this.searchParams.contract : this.searchParams.contractIds && this.searchParams.contractIds.length > 0 ? this.searchParams.contractIds[0] : null,
                    start_time: this.searchParams.dateFrom ? this.getDateIsoString(new Date(this.searchParams.dateFrom)) : null,
                    end_time: this.searchParams.dateTo ? this.getDateIsoString(new Date(this.searchParams.dateTo)) : null,
                }
                this.loading = true
                this.$emit('loading', true)
                this.restFetchParams(this.trafficControlUrl, mappedParams, this.handleResponse)
            }
        },
        handleResponse: function (response) {
            if (response) {
                this.trafficControlItems = response.data
            }
            this.loading = false
            this.$emit('loading', false)
        },
        showDetails(data) {
            this.trafficControlItem = data
        },
        closeAndUpdate() {
            this.trafficControlItem = null
            this.reportsVisible = false
            this.fetchTrafficControlReports()
        }
    }
}
</script>
